import React from "react";
import MobileLayout from "../../../layouts/MobileLayout";
import { useAuthStore } from "../../../store/authStore";
import MobileBackButton from "../../../components/mobile/MobileBackButton";
import { useNavigate } from "react-router-dom";

import "./Profile.css";
import ThemeToggle from "../../../components/mobile/ThemeToggle";

export default function Profile() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  if (!user) {
    return (
      <MobileLayout>
        <div className="employee-profile-page">
          <div className="employee-profile-content">
            <p>User information not available.</p>
          </div>
        </div>
      </MobileLayout>
    );
  }

  const employeeName =
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

  const profileAvatar =
    user?.gender?.toLowerCase() === "female"
      ? "https://cdn-icons-png.flaticon.com/512/6997/6997662.png"
      : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

  return (
    <MobileLayout>
      <div className="employee-profile-page">
        <div className="employee-profile-content">
          <div className="employee-profile-topbar">
            <MobileBackButton className="employee-profile-back" onClick={() => navigate(-1)} />

            <button
              className="employee-logout-btn"
              onClick={() => {
                logout();
                navigate("/", { replace: true }); // Change "/" if your login route is different
              }}
            >
              Logout
            </button>
          </div>

          {/* Top Section */}
          <div className="employee-profile-header">
            <div className="employee-profile-avatar">
              <img src={profileAvatar} alt="Profile" />
            </div>

            <h2 className="employee-profile-title">
              {employeeName || "Employee Name"}
            </h2>

            <p className="employee-profile-id">{user?.employee_code || "-"}</p>

            <p className="employee-profile-role">
              {user?.designation_name || "-"}
            </p>
          </div>

          <ThemeToggle />

          {/* Details Card */}
          <div className="employee-profile-card">
            <table className="employee-profile-table">
              <tbody>
                <tr>
                  <td>Employee Code</td>
                  <td>{user?.employee_code || "-"}</td>
                </tr>

                <tr>
                  <td>Email</td>
                  <td>{user?.email_id || "-"}</td>
                </tr>

                <tr>
                  <td>Mobile</td>
                  <td>
                    {user?.country_code
                      ? `${user.country_code} ${user.mobile_no}`
                      : user?.mobile_no || "-"}
                  </td>
                </tr>

                <tr>
                  <td>Location</td>
                  <td>{user?.location_name || "-"}</td>
                </tr>

                <tr>
                  <td>Department</td>
                  <td>{user?.department_name || "-"}</td>
                </tr>

                <tr>
                  <td>Designation</td>
                  <td>{user?.designation_name || "-"}</td>
                </tr>

                <tr>
                  <td>Reporting Manager</td>
                  <td>{user?.reporting_manager_name || "-"}</td>
                </tr>

                <tr>
                  <td>Role</td>
                  <td>{user?.role === 1 ? "Admin" : "User"}</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MobileLayout>
  );
}
